import { Dispatch } from 'redux';
import { ApiEndpoint } from '../constants/api-endpoints';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';

export const getEmployerChangeLogs = (clientNumber: string, payload: any, onSuccess: (data: any, dispatch?: Dispatch<any>) => any, onFailure?: (dispatch?: Dispatch<any>) => any): ApiAction => {
	return apiAction({
		method: HttpMethods.POST,
		url: `${ApiEndpoint.changeLogApi}/events/employer/${clientNumber}/changelog`,
		payloadData: payload,
		onSuccess,
		onFailure,
	});
};
